'use client';

export { PostComments } from './replies/thread';
